<template>
  <div>
    <head-nav-bar title="点菜" :fixed="true" />
    <div class="mt-header-nav restaurant-box">
      <div>
        <van-search
          v-model="keyword"
          placeholder="请输入搜索关键词"
          @input="onSearch"
        />
      </div>
      <van-row
        type="flex"
        justify="space-between"
        style="border-bottom: 1px solid #f2f2f2;"
      >
        <van-col span="5" class="food-sidebar">
          <van-sidebar v-model="foodClassKey">
            <van-sidebar-item
              v-for="item in foodClassList"
              :title="item.CategoryName"
              :key="item.CategoryId"
              :name="item.CategoryId"
              @click="foodClassChange($event, item)"
            />
          </van-sidebar>
        </van-col>
        <van-col span="19">
          <van-list
            :finished="finished"
            v-model="loading"
            finished-text="没有更多了"
            class="food-list"
          >
            <lazy-component>
              <div
                v-for="item in foodList"
                :key="item.DishId"
                class="food-item"
              >
                <span class="sold-out" v-if="item.IsSoldOut"></span>
                <van-card :class="{ disabled: item.IsSoldOut }">
                  <template slot="price">
                    ￥{{
                      isMemberOrder && item.MemberUnitPrice != null
                        ? item.MemberUnitPrice
                        : item.UnitPrice
                    }}
                    <van-tag
                      type="success"
                      round
                      v-if="isMemberOrder && item.MemberUnitPrice != null"
                      >会</van-tag
                    >
                  </template>
                  <template slot="thumb">
                    <img v-lazy="item.ImageUrl ? item.ImageUrl : noPic" />
                  </template>
                  <template #title>
                    <div class="food-title">
                      <span>
                        {{ item.DishName }}/<em>{{ item.UnitName }}</em></span
                      >
                      <span v-if="item.IsPack" @click="openPack(item)">
                        <van-tag color="#f60"
                          >套餐 &nbsp;<van-icon
                            :name="
                              openKeys.includes(item.DishId) ||
                              openKeys.includes(item.Id)
                                ? 'arrow-up'
                                : 'arrow-down'
                            "
                          />
                        </van-tag>
                      </span>
                    </div>
                  </template>
                  <template v-if="item.IsPack" #footer>
                    <ul
                      class="pack-detail"
                      :class="{
                        'pack-detail-open':
                          openKeys.includes(item.DishId) ||
                          openKeys.includes(item.Id),
                      }"
                    >
                      <li v-for="pack in item.PackDetails" :key="pack.Id">
                        {{ pack.Name }} x {{ pack.Quantity }}
                      </li>
                    </ul>
                  </template>
                  <template #num>
                    <span
                      class="theme-round"
                      v-if="!item.Quantity || item.Quantity == '0'"
                    >
                      <span
                        class=" van-stepper__plus add-btn"
                        @click="addFood(item)"
                      >
                      </span
                    ></span>

                    <van-stepper
                      class="theme-round"
                      style="text-align: right;"
                      @change="onStepperChange($event, item)"
                      @focus="onFocus"
                      v-model="item.Quantity"
                      :min="0"
                      :decimal-length="0"
                      v-else
                    />
                  </template>
                </van-card>
              </div>
            </lazy-component>
          </van-list>
        </van-col>
      </van-row>
      <van-goods-action :style="{ zIndex: zIndex }">
        <div slot="default" style="width:60%" @click="checkDetail">
          <div class="cur-table">
            当前桌台：<strong>{{ openTable.TableName }}</strong>
          </div>
          <div class="summary-info">
            <span>
              <van-icon name="shopping-cart-o" />总数：<em
                >{{ total.Quantity }}
              </em></span
            >
            <span>
              <van-icon name="balance-o" />总计：<em
                >&yen; {{ total.TotalPrice }}</em
              >
            </span>
          </div>
        </div>
        <van-goods-action-button
          type="danger"
          text="选好了"
          @click="createOrder"
        />
      </van-goods-action>
    </div>
    <van-popup
      v-model="visible"
      position="bottom"
      closeable
      :style="{ height: '50%' }"
    >
      <h3 class="selected-title pop-selected-title">已选择菜品</h3>
      <lazy-component>
        <div class="select-foods">
          <!-- <template v-for="el in foodClassList"> -->
          <template v-for="item in allFoodList">
            <van-card
              :price="
                isMemberOrder && item.MemberUnitPrice != null
                  ? item.MemberUnitPrice
                  : item.UnitPrice
              "
              :key="item.DishId"
              v-if="Number(item.Quantity) > 0"
            >
              <div slot="price" @click="editPrice(item)">
                &yen;{{
                  isMemberOrder && item.MemberUnitPrice != null
                    ? item.MemberUnitPrice
                    : item.UnitPrice
                }}
                <van-icon name="edit" class="edit-icon" />
              </div>
              <template #title>
                <div class="food-title">
                  <span>
                    {{ item.DishName }}/<em>{{ item.UnitName }}</em>
                    <van-tag color="#f60" v-if="item.IsPack" round>套</van-tag>
                    <van-button
                      v-if="!item.IsPack"
                      type="primary"
                      size="mini"
                      @click="addCookingMethod(item)"
                      >做法</van-button
                    >
                    <span
                      v-if="item.PracticeDesc || item.CookingMethodDesc"
                      class="method-txt"
                    >
                      「做法」{{ item.PracticeDesc
                      }}{{ item.CookingMethodDesc }}
                    </span>
                  </span>
                  <span>
                    <van-button type="info" size="mini" @click="giveFoods(item)"
                      >赠送</van-button
                    >
                  </span>
                </div>
              </template>

              <template #num>
                <van-stepper
                  class="theme-round"
                  style="text-align: right;"
                  @change="onStepperChange($event, item)"
                  @focus="onFocus"
                  v-model="item.Quantity"
                  :min="0"
                  :decimal-length="0"
                />
              </template>
            </van-card>
          </template>
          <!-- </template> -->
        </div>
      </lazy-component>
    </van-popup>
    <van-dialog
      v-model="showMethod"
      title="选择做法"
      @confirm="onSubmitMethod"
      show-cancel-button
    >
      <van-grid :gutter="10" class="cooking-methods">
        <van-grid-item
          v-for="item in cookingMethods"
          :key="item.Id"
          :text="item.Text"
          @click="chooseMethod(item)"
          :class="{ active: selectMethodIds.includes(item.Id) }"
        />
      </van-grid>
    </van-dialog>
    <van-dialog
      v-model="showMethodDesc"
      title="手写做法"
      @confirm="onSubmitMethodDesc"
      show-cancel-button
    >
      <van-field v-model="CookingMethodDesc" label="做法" clearable />
    </van-dialog>
    <ConfirmOrder ref="ConfirmOrder" @close="zIndex = 9999"></ConfirmOrder>
    <van-dialog
      v-model="showEditPrice"
      title="修改价格"
      @close="zIndex = 9999"
      @confirm="confirmPrice"
      show-cancel-button
    >
      <van-field v-model="number" type="number" label="价格" clearable />
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Row,
  Col,
  Icon,
  Sidebar,
  Search,
  Stepper,
  SidebarItem,
  List,
  Cell,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Card,
  Tag,
  Popup,
  Notify,
  Lazyload,
  Button,
  Grid,
  GridItem,
  Field,
  Dialog,
} from "vant";
Vue.use(Lazyload, {
  lazyComponent: true,
});
import ConfirmOrder from "./ConfirmOrder.vue";
import { accAdd, accMul, trimStr } from "@/utils/common";
import noPic from "@/assets/images/nopic.png";
import "./restarant.less";
// import { ls } from "@/utils/cache.js";
import restaurantApi from "@/api/restaurant.js";
// import restaurantManageApi from "@/api/restaurantManage.js";
// import cloneDeep from "lodash/cloneDeep";
import { getSelectData } from "@/api/common.js";
export default {
  name: "OrderFood",
  components: {
    ConfirmOrder,
    [Dialog.Component.name]: Dialog.Component,
    [Grid.name]: Grid,
    [Field.name]: Field,
    [GridItem.name]: GridItem,
    [Button.name]: Button,
    [Notify.name]: Notify,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Col.name]: Col,
    [Search.name]: Search,
    [Stepper.name]: Stepper,
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
    [List.name]: List,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Cell.name]: Cell,
  },
  watch: {
    allFoodList: {
      handler: function(list) {
        let total = 0,
          num = 0;
        // list.forEach(el => {
        list.forEach(item => {
          item.Quantity = item.Quantity ? item.Quantity : 0;
          item.TotalPrice = item.TotalPrice ? item.TotalPrice : 0;
          num = accAdd(num, item.Quantity);
          total = accAdd(total, item.TotalPrice);
        });
        // });

        this.total.Quantity = num;
        this.total.TotalPrice = total;
      },
      deep: true,
    },
  },
  data() {
    return {
      noPic,
      foodClassKey: "0",
      foodClassList: [],
      foodList: [],
      loading: false,
      finished: true,
      total: {
        Quantity: 0,
        TotalPrice: 0,
      },
      visible: false,
      orderId: "",
      cookingMethods: [],
      showMethod: false,
      selectMethodIds: [],
      CookingMethodDesc: "",
      showMethodDesc: false,
      orderData: {},
      openTableList: [],
      openTable: {}, //当前桌台
      tableInfo: {},
      openKeys: [],
      member: {},
      isMemberOrder: false,
      zIndex: 9999,
      showEditPrice: false,
      number: 0,
      currentDish: {},
      keyword: "",
      allFoodList: [],
      // tbaleNames:''
    };
  },
  created() {
    // ls.remove("order_data");

    this.orderId = this.$route.query.orderId;
    if (!this.orderId) {
      this.$message.error("缺少必要参数");
      this.$router.push({
        name: "restarantManageIndex",
      });
      return;
    }
    getSelectData({
      Types: "CookingMethod",
    }).then(res => {
      this.cookingMethods = res.Data.CookingMethod;
      this.cookingMethods.push({
        Id: "0",
        Text: "手写",
      });
    });

    this.fetchOrderData().then(() => {
      this.fetchFoodList();
    });
  },
  methods: {
    onSearch(/*val*/) {
      const { foodClassKey, foodClassList, keyword } = this;
      const find = foodClassList[foodClassKey];
      if (find && find.DishList) {
        const foodList = find.DishList;
        this.foodList = foodList.filter(item => {
          if (
            keyword &&
            item.SimpleCode.indexOf(trimStr(keyword.toUpperCase())) < 0
          ) {
            // 关键词查询，且菜品名称不存在关键词的
            return false;
          }
          return true;
        });
      }
    },
    editPrice(item) {
      this.showEditPrice = true;
      this.currentDish = item;
      this.number = item.UnitPrice;
      this.zIndex = 2007;
    },
    confirmPrice() {
      this.zIndex = 9999;
      this.currentDish.UnitPrice = this.number;
      this.currentDish.TotalPrice = accMul(
        this.currentDish.Quantity,
        this.number,
      );
      this.currentDish.FinalPrice = this.currentDish.TotalPrice;
    },
    fetchOrderData() {
      return new Promise((resolve, reject) => {
        restaurantApi
          .getOrderDetail({
            Id: this.orderId,
          })
          .then(res => {
            this.orderData = res.Data;
            this.member = {
              Id: res.Data.MemberCardId,
              Name: res.Data.MemberName,
            };
            this.isMemberOrder = res.Data.MemberCardId ? true : false;
            // const tbaleNames = res.Data.DishTables.map(p => p.TableName);
            // this.tbaleNames = tbaleNames;
            this.openTableList = res.Data.DishTables;
            if (this.$route.query.tableId) {
              this.openTable = res.Data.DishTables.find(
                item => item.TableId === this.$route.query.tableId,
              );
            } else {
              this.openTable = res.Data.DishTables[0];
            }

            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    openPack(item) {
      let id = item.Id ? item.Id : item.DishId;
      if (this.openKeys.includes(id)) {
        this.openKeys = this.openKeys.filter(el => el != id);
      } else {
        this.openKeys.push(id);
      }
    },
    fetchFoodList() {
      restaurantApi
        .getDishList({ OnlyInSelling: false, IsPack: true })
        .then(res => {
          const data = res.Data;
          let allList = [];
          data.forEach(el => {
            el.DishList.forEach(item => {
              item.Quantity = 0;
              item.TotalPrice = 0;
              item.ImageUrl = item.ImageUrl
                ? this.$config.http.serverUrl + item.ImageUrl
                : "";
            });
            allList = [...allList, ...el.DishList];
          });
          this.foodClassList = [
            {
              CategoryId: 0,
              CategoryName: "全部",
              DishList: allList,
            },
            ...data,
          ];
          this.allFoodList = allList;
          this.foodList = this.allFoodList;
        });
    },
    foodClassChange(index) {
      if (index == 0) {
        this.foodList = this.allFoodList;
      } else {
        this.foodList = this.allFoodList.filter(
          el => el.CategoryId == this.foodClassList[index].CategoryId,
        );
      }
      this.keyword = "";
      this.openKeys = [];
    },
    giveFoods(item) {
      item.UnitPrice = 0;
      item.TotalPrice = 0;
      item.DiscountPrice = 0;
      item.FinalPrice = 0;
    },
    addCookingMethod(item) {
      this.showMethod = true;
      this.currentFood = item;
      this.selectMethodIds =
        item.CookingMethodIds && item.CookingMethodIds.length
          ? item.CookingMethodIds
          : [];
    },
    onSubmitMethod() {
      this.currentFood.CookingMethodIds = this.selectMethodIds;
      this.currentFood.PracticeDesc = this.cookingMethods
        .filter(p => this.selectMethodIds.includes(p.Id))
        .map(p => p.Text)
        .join(",");
    },
    chooseMethod(item) {
      if (item.Id == 0) {
        this.showMethodDesc = true;
        this.CookingMethodDesc = this.currentFood.CookingMethodDesc;
      } else if (this.selectMethodIds.includes(item.Id)) {
        this.selectMethodIds = this.selectMethodIds.filter(el => el != item.Id);
      } else {
        this.selectMethodIds.push(item.Id);
      }
    },
    onSubmitMethodDesc() {
      this.currentFood.CookingMethodDesc = this.CookingMethodDesc;
      this.showMethod = false;
    },
    addFood(item) {
      if (item.IsSoldOut) {
        return false;
      }
      item.Quantity = Number(item.Quantity) + 1;
      const price =
        this.isMemberOrder && item.MemberUnitPrice != null
          ? item.MemberUnitPrice
          : item.UnitPrice;
      item.TotalPrice = accMul(item.Quantity, price);
    },
    onStepperChange(val, item) {
      const price =
        this.isMemberOrder && item.MemberUnitPrice != null
          ? item.MemberUnitPrice
          : item.UnitPrice;
      item.TotalPrice = accMul(item.Quantity, price);
    },
    onFocus(e) {
      e.currentTarget.select();
    },
    checkDetail() {
      this.visible = true;
    },
    delItem(item) {
      item.Quantity = 0;
      item.TotalPrice = 0;
    },
    createOrder() {
      let list = [];
      // this.foodClassList.forEach(el => {
      const data = this.allFoodList.filter(item => Number(item.Quantity) > 0);
      list = list.concat(data);
      // });
      if (!list.length) {
        Notify({ type: "danger", message: "您还没有选择任何菜品" });
        return false;
      }
      this.zIndex = 10;
      this.$refs.ConfirmOrder.show(this.orderData, list, this.total);
      // this.$router.push({
      //   name: "restarantManageIndex",
      //   query: { OrderId: this.orderId }
      // });
    },
  },
};
</script>
<style lang="less" scoped>
.cur-table {
  padding-left: 20px;
  font-size: 14px;
  strong {
    color: #000;
  }
}
.summary-info {
  font-size: 12px;
  line-height: 24px;
}
</style>
